import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  type AvatarSize,
} from "@/components/ui/avatar";

interface UserAvatarProps {
  avatar?: string | null;
  name: string;
  email?: string;
  size?: AvatarSize;
  className?: string;
}

export function UserAvatar({
  avatar,
  name,
  email,
  size = "md",
  className,
}: UserAvatarProps) {
  const initials = (name || "U")
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  return (
    <Avatar size={size} className={className}>
      <AvatarImage src={avatar || undefined} alt={email || name} />
      <AvatarFallback>{initials}</AvatarFallback>
    </Avatar>
  );
}
